<template>
  <div id="app">
    <div id="nav">
      <!--<router-link to="/">Home</router-link>-->
    </div>
    <div v-if="$root.loading" class='mt-5'>
      <img height="100px" src="/loading.gif" alt="Loading..." />
    </div>
    <router-view v-else />
  </div>
</template>
<script>  
export default{
  props: ["loading"]
}
</script>

<style lang="scss">
.btn-primary{
  background-color: $primary !important; 
  border-color: $primary !important;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: $primary-dark !important;
    border-color: $primary-dark !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
  }
}

div.contact_left a{
  color: $primary !important;
  transition: color 0.2s ease;
}
div.contact_left a:hover{
  color: $primary-dark !important;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-dark;
  margin: 0;
  padding: 0;
  background-color: $bg-light;
}


</style>
